import "./progress.css";
import "react-alice-carousel/lib/alice-carousel.css";
import React from "react";

const Progress = () => {
  return (
    <section id="skills">
      <div className="progress-container">
        <div className="progress-title">
          <h2>My Skills Progress so far</h2>
          <h3>My Skills</h3>
        </div>
        <div className="progress-row2">
          <div className="lang">
            {/*  Vuejs */}
            <div className="mylang">
              <div className="lang-info">
                <div className="lang-img">
                  <img
                    width="48"
                    height="48"
                    src="https://img.icons8.com/fluency/48/vuejs.png"
                    alt="vuejs"
                  />
                </div>
                <h3>Vuejs </h3>
              </div>
            </div>

            {/*  Javascript */}
            <div className="mylang">
              <div className="lang-info">
                <div className="lang-img">
                  <img
                    width="48"
                    height="48"
                    src="https://img.icons8.com/color/48/javascript--v1.png"
                    alt="javascript--v1"
                  />
                </div>
                <h3>Javascript</h3>
              </div>
            </div>
            {/* react js */}
            <div className="mylang">
              <div className="lang-info">
                <div className="lang-img">
                  <img
                    width="64"
                    height="64"
                    src="https://img.icons8.com/nolan/64/react-native.png"
                    alt="react"
                  />
                </div>
                <h3>React js</h3>
              </div>
            </div>

            {/* React native  */}
            <div className="mylang">
              <div className="lang-info">
                <div className="lang-img">
                  <img
                    width="64"
                    height="64"
                    src="https://img.icons8.com/nolan/64/react-native.png"
                    alt="react-native"
                  />
                </div>
                <h3>React Native</h3>
              </div>
            </div>
            {/* PHP */}
            <div className="mylang">
              <div className="lang-info">
                <div className="lang-img">
                  <img
                    src="https://img.icons8.com/color/48/null/php.png"
                    alt=""
                  />
                </div>
                <h3>PHP</h3>
              </div>
            </div>
            {/* Laravel */}
            <div className="mylang">
              <div className="lang-info">
                <div className="lang-img">
                  <img
                    width="48"
                    height="48"
                    src="https://img.icons8.com/fluency/48/laravel.png"
                    alt="laravel"
                  />
                </div>
                <h3>Laravel </h3>
              </div>
            </div>
            {/* Codeigniter */}
            <div className="mylang">
              <div className="lang-info">
                <div className="lang-img">
                  <img
                    width="24"
                    height="24"
                    src="https://img.icons8.com/external-tal-revivo-color-tal-revivo/24/external-codeigniter-is-an-open-source-software-rapid-development-web-framework-logo-color-tal-revivo.png"
                    alt="external-codeigniter-is-an-open-source-software-rapid-development-web-framework-logo-color-tal-revivo"
                  />
                </div>
                <h3>Codeigniter </h3>
              </div>
            </div>
            {/* Nodejs */}
            <div className="mylang">
              <div className="lang-info">
                <div className="lang-img">
                  <img
                    src="https://img.icons8.com/color/48/null/nodejs.png"
                    alt=""
                  />
                </div>
                <h3>Nodejs </h3>
              </div>
            </div>
            {/* django */}
            <div className="mylang">
              <div className="lang-info">
                <div className="lang-img">
                  <img
                    width="50"
                    height="50"
                    src="https://img.icons8.com/ios-filled/50/django.png"
                    alt="django"
                  />
                </div>
                <h3>Django</h3>
              </div>
            </div>
            {/* Python */}
            <div className="mylang">
              <div className="lang-info">
                <div className="lang-img">
                  <img
                    width="48"
                    height="48"
                    src="https://img.icons8.com/color/48/python--v1.png"
                    alt="python--v1"
                  />
                </div>
                <h3>Python</h3>
              </div>
            </div>

            {/* mysql */}
            <div className="mylang">
              <div className="lang-info">
                <div className="lang-img">
                  <img
                    width="48"
                    height="48"
                    src="https://img.icons8.com/color/48/mysql-logo.png"
                    alt="mysql-logo"
                  />
                </div>
                <h3>Mysql</h3>
              </div>
            </div>
            {/* mongoDB */}
            <div className="mylang">
              <div className="lang-info">
                <div className="lang-img">
                  <img
                    width="24"
                    height="24"
                    src="https://img.icons8.com/external-tal-revivo-filled-tal-revivo/24/external-mongodb-a-cross-platform-document-oriented-database-program-logo-filled-tal-revivo.png"
                    alt="external-mongodb-a-cross-platform-document-oriented-database-program-logo-filled-tal-revivo"
                  />
                </div>
                <h3>MongoDB</h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Progress;
